import { motion, useAnimation } from 'framer-motion';
import { useEffect } from 'react';
import Image from 'next/image';
import { Box, Flex, Link } from '@terminal/design-system';

const MotionBox = motion(Box);

export default function TerminalDifferenceAnimation({ hero }) {
  const links = useAnimation();

  useEffect(() => {
    links.start((i) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: i * 0.5,
        duration: 1.5,
        type: 'spring',
        bounce: 0.5,
      },
    }));
  }, [links]);

  return (
    <>
      {hero.roles.map((role, index) => (
        <MotionBox key={role.role} animate={links} initial={{ y: -30, opacity: 0 }} custom={index}>
          <Link
            href={role.url}
            display="block"
            bgColor="white"
            borderRadius="6.25rem"
            p="1rem 1.3125rem"
            mb="5"
            maxW="25rem"
            transition="box-shadow 0.2s ease-in-out"
            _hover={{
              textDecoration: 'none',
              boxShadow: '0 0.5rem 0.8rem rgba(28, 40, 45, 0.2)',
            }}
          >
            <Flex alignItems="center">
              <Box w="2.5rem" h="2.5rem" position="relative" mr="4" flexShrink={0}>
                <Image src={role.icon} alt="" style={{ objectFit: 'contain' }} fill />
              </Box>
              <Flex alignItems="center" flex="1" justifyContent="space-between">
                <Box fontSize="1.75rem" lineHeight="2.125rem" fontWeight="semibold">
                  {role.role}
                </Box>
                <Box>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.20874 13H16.3787L11.4987 17.88C11.1087 18.27 11.1087 18.91 11.4987 19.3C11.8887 19.69 12.5187 19.69 12.9087 19.3L19.4987 12.71C19.8887 12.32 19.8887 11.69 19.4987 11.3L12.9187 4.69996C12.7319 4.5127 12.4783 4.40747 12.2137 4.40747C11.9492 4.40747 11.6956 4.5127 11.5087 4.69996C11.1187 5.08996 11.1187 5.71996 11.5087 6.10996L16.3787 11H5.20874C4.65874 11 4.20874 11.45 4.20874 12C4.20874 12.55 4.65874 13 5.20874 13Z"
                      fill="#7AA550"
                    />
                  </svg>
                </Box>
              </Flex>
            </Flex>
          </Link>
        </MotionBox>
      ))}
    </>
  );
}
